var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"full"},[_c('Renderer',{ref:"renderer",attrs:{"size":_vm.size},on:{"renderer":function (v) { _vm.renderer = v }}},[_c('keep-alive',[(_vm.renderer)?_c('router-view',{tag:"component",staticClass:"full",attrs:{"doc":_vm.doc,"size":_vm.size,"renderer":_vm.renderer}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48199d60","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/scene-builder/SceneViewer.vue
// module id = 623
// module chunks = 2